function initScholarshipTabs() {
    const tabBlocks = document.querySelectorAll('.scholarship-tabs');
    
    tabBlocks.forEach(block => {
        const filterLabel = block.querySelector('.filter-label span');
        const navLinks = block.querySelectorAll('.nav-link');
        
        navLinks.forEach(link => {
            link.addEventListener('click', () => {
                // Scroll to top of block with smooth animation
                block.scrollIntoView({ behavior: 'smooth' });
                if (filterLabel) {
                    filterLabel.textContent = link.textContent.trim();
                }

                // close filter dropdown
                const filterDropdown = link.closest('.filter-dropdown');
                filterDropdown.querySelector('.filter-label').classList.remove('is-open');
                filterDropdown.querySelector('.filter-buttons').classList.remove('is-open');
            });
        });
    });
};

function updateTabsNavigation() {
    const $tabsNav = $('.tabs-navigation');
    const headerHeight = $('#siteHeader').outerHeight();
    const tabsNavTop = $tabsNav.offset().top - headerHeight;
    
    $(window).on('scroll', function() {
        const scrollTop = $(window).scrollTop();
        
        if (scrollTop >= tabsNavTop) {
            $tabsNav.addClass('is-sticky');
        } else {
            $tabsNav.removeClass('is-sticky');
        }
    });
    
    $tabsNav.css('top', headerHeight + 10 + 'px'); // Adding 10px buffer
}

// Update on resize
if($('.tabs-navigation').length) {
    $(window).on('resize', updateTabsNavigation);
    updateTabsNavigation();
}

initScholarshipTabs(); 